"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EQuestionCategory = void 0;
const enum_1 = require("../../../../utils/enum");
exports.EQuestionCategory = (0, enum_1.strEnum)(["GENERAL", "CASTING"]);
